import React, { useEffect } from 'react';
import { generateStructuredData, businessData } from './seoConfig';

interface SEOHelmetProps {
  title: string;
  description: string;
  keywords: string;
  ogImage?: string;
  ogUrl?: string;
  structuredData?: object;
}

export const SEOHelmet: React.FC<SEOHelmetProps> = ({
  title,
  description,
  keywords,
  ogImage = '/gigi-og-image.png',
  ogUrl = 'https://gigihairbraiding.com',
  structuredData,
}) => {
  useEffect(() => {
    // Update page title
    document.title = title;

    // Update or create meta tags
    const updateMetaTag = (name: string, content: string) => {
      let tag = document.querySelector(`meta[name="${name}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('name', name);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };

    const updateOgTag = (property: string, content: string) => {
      let tag = document.querySelector(`meta[property="${property}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('property', property);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };

    // Standard Meta Tags
    updateMetaTag('description', description);
    updateMetaTag('keywords', keywords);
    updateMetaTag('viewport', 'width=device-width, initial-scale=1');

    // Open Graph Tags
    updateOgTag('og:title', title);
    updateOgTag('og:description', description);
    updateOgTag('og:image', ogImage);
    updateOgTag('og:url', ogUrl);
    updateOgTag('og:type', 'website');

    // Twitter Card Tags
    updateMetaTag('twitter:card', 'summary_large_image');
    updateMetaTag('twitter:title', title);
    updateMetaTag('twitter:description', description);
    updateMetaTag('twitter:image', ogImage);

    // Local Business Schema
    const localSchema = structuredData || generateStructuredData();
    const schemaScript = document.getElementById('local-business-schema');
    if (schemaScript) {
      schemaScript.remove();
    }

    const script = document.createElement('script');
    script.id = 'local-business-schema';
    script.type = 'application/ld+json';
    script.innerHTML = JSON.stringify(localSchema);
    document.head.appendChild(script);
  }, [title, description, keywords, ogImage, ogUrl, structuredData]);

  return null;
};

export default SEOHelmet;
